import FitAssistantStep from '../Enums/FitAssistantStep.ts';
import { StepData, StepDataData } from '../Types/FitAssistantData.ts';
import { MatchingProduct } from '../Types/MatchingProducts.ts';

export function getSelectedNonRoofRackStepData(stepData: StepData[] | undefined): StepDataData | undefined {
  if (!stepData?.length) return undefined;
  const step = [...stepData]
    .reverse()
    .find((s) => s.parameters !== FitAssistantStep.RoofRacks && s.data?.some((d) => d.Selected));
  return step?.data.find((d) => d.Selected);
}

// Answered from the variation, before the rack step is fetched: could any of its racks carry this tent?
export function rooftopTentHasEligibleRacks(selected: StepDataData | undefined, tentWeight: number): boolean {
  if (!selected?.HasRacksForTent || Number.isNaN(tentWeight)) return false;
  return selected.AggregateDynamicMaxWeightSolutionKg >= tentWeight;
}

export function rackOptionSupportsTentWeight(option: StepDataData, tentWeight: number): boolean {
  if (option.DynamicMaxWeightSolutionKg == null || Number.isNaN(tentWeight)) return false;
  return option.DynamicMaxWeightSolutionKg >= tentWeight;
}

export function getTentWeightForMatchingProducts(
  matchingProducts: MatchingProduct[] | undefined,
  productPimId: string | undefined
): number {
  if (!matchingProducts?.length) return 0;
  if (productPimId) {
    const mp = matchingProducts.find((p) => p.PimId === productPimId || p.ProductIds?.includes(productPimId));
    if (mp != null) return mp.TentWeight ?? 0;
  }
  return 0;
}
